import dayjs from 'dayjs'
import { newAppealState } from 'feature/appeals/redux/appealFormCreateSelector'
import { useAppealManagerMutation } from 'feature/appeals/redux/appeals.api'
import { TAppealManagerRequest } from 'feature/appeals/type'
import { useSetNotice } from 'hooks/useSetNotice'
import { FieldValues, SubmitHandler } from 'react-hook-form'
import { useAppSelector } from 'store/hooks'
import { Severity } from 'widget/Notifications'

import { OrderManageDateForm } from '../OrderManageDateFrom/OrderManageDateForm'

type TMainOrderManage = {
  handleBack: () => void
  title: string
  description: string
  onSubmit?: SubmitHandler<FieldValues>
  isLoading?: boolean
  onClose: () => void
}

// обертка для формы переноса даты заявки

export function OrderManageDateContainerForm({
  handleBack,
  title,
  description,
  onClose,
}: TMainOrderManage) {
  const [appealManager, { isLoading }] = useAppealManagerMutation()
  const { uid, orderId } = useAppSelector(newAppealState)

  const setNotice = useSetNotice()

  const onSubmit: SubmitHandler<FieldValues> = values => {
    const date = dayjs(values.date).format('YYYY-MM-DD')
    const time = dayjs(values.time).format('HH:mm:ss')

    const requestBody: TAppealManagerRequest = {
      url: 'change-measurement-datetime',
      uid,
      orderId,
      datetime: date + ' ' + time,
      comment: values.comment,
    }
    appealManager(requestBody).then(res => {
      if ('error' in res) {
        //@ts-ignore
        const error = res.error.data
        setNotice(error.message, Severity.error)
        return
      }
      onClose()
      setNotice('Заявка успешно отправлена', Severity.success)
    })
  }

  return (
    <OrderManageDateForm
      handleBack={handleBack}
      title={title}
      description={description}
      onSubmit={onSubmit}
      isLoading={isLoading}
    />
  )
}
